<template>
  <PlanSummaryCardText :title="planSummaryTitle" :pricing="planPricing" :subheading="subheading" :trialInfo="trialDisplay" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import PlanSummaryCardText from './PlanSummaryCardText.vue'
import { useCheckoutStore } from '@/store/CheckoutStore'
import { usePlanStore } from '@/store/PlanStore'
import { usePriceStore } from '@/store/PriceStore'
import { useProductStore } from '@/store/ProductStore'
import { useTrialStatus } from '@/composables/useTrialStatus'
const checkoutStore = useCheckoutStore()
const planStore = usePlanStore()
const priceStore = usePriceStore()
const productStore = useProductStore()

const { country } = storeToRefs(checkoutStore)
const { name: productName } = storeToRefs(productStore)
const { selectedPlanDisplayPrice } = storeToRefs(priceStore)

const { selectedPlanIntervalAsNoun, selectedPlanTrialLengthDisplay } = storeToRefs(planStore)

const { planHasTrial } = useTrialStatus()

const preTaxDetails = computed(() => (country.value === 'US' ? '(pre-tax)' : ''))

const planSummaryTitle = computed(() => productName.value)
const subheading = computed(() => `${trialEmailDisplay.value} Cancel anytime.`)

const planPricing = computed(() => `${selectedPlanDisplayPrice.value}/${selectedPlanIntervalAsNoun.value} ${preTaxDetails.value}`)

const trialDisplay = computed(() => (planHasTrial.value ? `after a ${selectedPlanTrialLengthDisplay.value} trial.` : 'starting today.'))
const trialEmailNotice = "We'll remind you three days before your trial ends."
const trialEmailDisplay = computed(() => (planHasTrial.value ? trialEmailNotice : ''))
</script>
